import ReactPlayer from "react-player";

export default function VideoPlayer({ url, muted = true}) {
  return (
    <div className="player-wrapper">
      <ReactPlayer
        className="react-player"
        url={url}
        playing
        controls
        muted={muted}
        loop
        width="100%"
        height="100%"
      />
    </div>
  );
}
